var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuWhatsNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9792 3.4375C13.6852 4.61244 11.1846 5.32993 8.61667 5.55C8.04333 5.6 7.46167 5.625 6.875 5.625H6.25C5.25544 5.625 4.30161 6.02009 3.59835 6.72335C2.89509 7.42661 2.5 8.38044 2.5 9.375C2.5 10.3696 2.89509 11.3234 3.59835 12.0266C4.30161 12.7299 5.25544 13.125 6.25 13.125H6.875C7.46167 13.125 8.04333 13.15 8.61667 13.2M8.61667 13.2C8.8275 14.0017 9.10333 14.7767 9.4375 15.5192C9.64333 15.9775 9.4875 16.5275 9.05167 16.7783L8.50417 17.095C8.045 17.36 7.45417 17.1925 7.23167 16.7108C6.70358 15.5684 6.30121 14.3719 6.03167 13.1425M8.61667 13.2C8.28915 11.9514 8.1239 10.6658 8.125 9.375C8.125 8.05333 8.29583 6.77167 8.61667 5.55M8.61667 13.2C11.1846 13.4201 13.6852 14.1376 15.9792 15.3125M15.9792 3.4375C16.4325 4.8987 16.716 6.40725 16.8242 7.93333C16.8925 8.89323 16.8925 9.85677 16.8242 10.8167C16.716 12.3427 16.4325 13.8513 15.9792 15.3125C15.8808 15.6292 15.775 15.9408 15.6625 16.25M15.9792 3.4375C15.8814 3.12241 15.7759 2.80981 15.6625 2.5M16.8242 7.93333C17.2367 8.2775 17.5 8.79583 17.5 9.375C17.5 9.95417 17.2367 10.4725 16.8242 10.8167",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuWhatsNew);
export default __webpack_public_path__ + "static/media/menu_whats_new.396072456ccfe126a0d27fe7963d568a.svg";
export { ForwardRef as ReactComponent };